import { useCallback } from "react";
import { track } from "../../analytics/AnalyticsService.js";
import { AnalyticsTrackingEvent } from "../../analytics/events.js";
import { useConciergeContext } from "../ConciergeContextProvider.js";
const useProductSuggestedTracking = () => {
  const { conversationId } = useConciergeContext();
  const trackProductSuggested = useCallback(
    (params) => {
      if (!conversationId) {
        console.warn("[Concierge] Cannot track product suggested: no conversationId");
        return;
      }
      const properties = {
        conversationId,
        stacklineSku: params.stacklineSku,
        title: params.title,
        productTitle: params.productTitle,
        retailerName: params.retailerName,
        retailerId: params.retailerId,
        retailerSku: params.retailerSku,
        retailerParentSku: params.retailerParentSku,
        brandId: params.brandId,
        brandName: params.brandName,
        categoryId: params.categoryId,
        categoryName: params.categoryName,
        groupId: params.groupId,
        groupName: params.groupName,
        subCategoryId: params.subCategoryId,
        subCategoryName: params.subCategoryName,
        retailPrice: params.retailPrice,
        prompt: params.prompt,
        appName: params.appName,
        appConfigId: params.appConfigId,
        appId: params.appId,
        brandIds: params.brandIds
      };
      track(AnalyticsTrackingEvent.CONCIERGE_PRODUCT_SUGGESTED, properties).catch((err) => {
        console.warn("[Concierge] Failed to track product suggested:", err);
      });
    },
    [conversationId]
  );
  return { trackProductSuggested, conversationId };
};
export {
  useProductSuggestedTracking
};
//# sourceMappingURL=useProductSuggestedTracking.js.map
